import { createModuleApi } from '@wit-support/admin-client-core';
const api = createModuleApi({ errorFormat: 'server-message' });
export function setTemplatesApiBaseUrl(url) {
    api.setBaseUrl(url);
}
export async function listTemplates() {
    const body = await api.get('/api/templates');
    return body.items;
}
/**
 * Fetch the default email layout for the template editor's live preview.
 * Returns `null` (not throws) when the server has no layout seeded —
 * the preview then degrades to a raw inner-HTML view so the editor still
 * works.
 */
export async function fetchEmailLayout() {
    const r = await api.fetchRaw('/api/email-layout');
    if (!r.ok)
        return null;
    return (await r.json());
}
/**
 * Fetch the static provider catalog driving the template "data action" binding —
 * `{ key, label, fields: { path, label, type }[] }[]`. The shape is the seam that
 * becomes a live fetch later; the editor renders it as-is.
 */
export async function fetchTemplateDataProviders() {
    return api.get('/api/template-data-providers');
}
export async function getTemplate(id) {
    return api.get(`/api/templates/${id}`);
}
export async function createTemplate(body) {
    return api.post('/api/templates', body);
}
export async function updateTemplate(id, body) {
    return api.patch(`/api/templates/${id}`, body);
}
export async function deleteTemplate(id) {
    const r = await api.del(`/api/templates/${id}`);
    if (!r.ok) {
        const msg = await api.extractServerError(r);
        throw new Error(msg);
    }
}
//# sourceMappingURL=api.js.map